<template>
  <div class="shop-hezi">
    <!-- <div class="shop-top">
      <div style="position: relative">
        <a href="/product/detail/205"
          ><img src="../../assets/images/heziShopImg1.png" alt=""
        /></a>
        <div class="end-time">
          距结束剩 <span>{{ h }}</span> : <span>{{ m }}</span> :
          <span>{{ s }}</span>
        </div>
      </div>
      <div class="shop-fiex-img">
        <a href=""><img src="../../assets/images/heziShopImg2.png" alt="" /></a>
        <a href=""><img src="../../assets/images/heziShopImg3.png" alt="" /></a>
      </div>
      <div>
        <a href=""><img src="../../assets/images/heziShopImg4.png" alt="" /></a>
      </div>
    </div> -->
    <div class="shop-top">
      <div
        style="position: relative"
        v-for="(temp, ind) in imagesData"
        :key="ind"
        :id="ind == 1 ? 'shop_mao' : ''"
        :class="ind != 0  ? 'shop-fiex-img' : ''"
        @click="toUrl(temp.url)"
      >
        <img :src="temp.image" alt="" />
        <div class="end-time" v-if="ind == 0">
          距结束剩 <span>{{ h }}</span> : <span>{{ m }}</span> :
          <span>{{ s }}</span>
        </div>
      </div>
    </div>
    <div class="shop-footer">
      <p class="footer-top">{{ footerTitle }}</p>
      <div class="footer-btn">
        <a :href="direct_url" class="btnA btn-one">{{ footerTitle2 }}</a>
        <span @click="$router.push('/')" class="btnA btn-two"
          >逛逛学习严选</span
        >
      </div>
      <p class="footer-bottom">优质的教育资源属于每个孩子</p>
      <p class="footer-txt">
        <img src="../../assets/images/hezishopimg5.png" alt="" />
      </p>
    </div>
    <!-- <div style="float: left;height: 1rem"></div> -->
  </div>
</template>

<script>
import { getPurchase } from "@api/user";
import CountDown from "@components/CountDown";
import cookie from "@utils/store/cookie";
const ACTIVITY_URL = "activity_url";
export default {
  name: "ShopHezi",
  components: {
    CountDown,
  },
  data() {
    return {
      datatime: "111",
      h: "",
      m: "",
      s: "",
      day: "",
      imagesData: [],
      end_time: "",
      footerTitle: "",
      direct_url: "",
      is_purchase: false,
      is_purchaseUrl: "",
      footerTitle2: "",
    };
  },
  created() {
    let activityHref = window.location.pathname;
    sessionStorage.setItem(ACTIVITY_URL,activityHref)
    // cookie.set(ACTIVITY_URL, activityHref);
    this.countTime();
  },
  mounted() {
    this.heziLogin();
    // console.log('mounted');
  },

  methods: {
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    toUrl(url) {
      window.location.href = url;
    },
    heziLogin() {
      var that = this;
      let id = this.$route.params.id;
      getPurchase(id)
        .then((res) => {
          console.log(res);
          that.end_time = res.data.info.end_time;
          that.imagesData = res.data.info.images;
          that.footerTitle = res.data.info.title[6];
          that.direct_url = res.data.info.direct_url;
          that.footerTitle2 = res.data.info.title[7];
          if (res.data.info.is_purchase) {
            that.direct_url = "/order/list/1";
            that.footerTitle2 = res.data.info.title[8];
          }
          let zhiboUrl = this.GetQueryString("direct_url");
          if (zhiboUrl) {
            that.direct_url = zhiboUrl;
            if (res.data.info.is_purchase) {
              that.direct_url = "/order/list/1";
              that.footerTitle2 = res.data.info.title[8];
            }
          }
          var r = this.GetQueryString("flag");
          if (r) {
            setTimeout(() => {
              let top = document.getElementById("shop_mao").offsetTop;
              console.log(top);
              window.scrollTo(0, top - 5);
            }, 500);
          }
          that.countTime();
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
        });
    },
    countTime() {
      var that = this;
      var getTime = function (time) {
        var myDate = new Date(time);
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
          var t = new Date(time.replace(/-/g, "/")).getTime();
        } else {
          var t = myDate.getTime();
        }
        return t;
      };
      // 对结束时间进行处理渲染到页面
      let endTime = new Date(that.end_time * 1000);
      var interval = setInterval(() => {
        // 获取当前时间，同时得到活动结束时间数组
        let newTime = new Date().getTime();
        let obj = null; // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000; // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt((time % (60 * 60 * 24)) / 3600);
          let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          obj = {
            day: this.timeFormat(day),
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec),
          };
        } else {
          // 活动已结束，全部设置为'00'
          // console.log("活动结束")
          obj = {
            day: "00",
            hou: "00",
            min: "00",
            sec: "00",
          };
          clearInterval(interval);
        }
        this.d = obj.day;
        this.h = obj.hou;
        this.m = obj.min;
        this.s = obj.sec;
        // 　　　　　　　　this.countDownList = obj.day + ':' + obj.hou + ':' + obj.min + ':' + obj.sec;
      }, 1000);
    },
    timeFormat(param) {
      return param < 10 ? "0" + param : param;
    },
  },
};
</script>

<style scoped>
.shop-hezi {
  margin: 0;
  padding: 0;
  background: url(../../assets/images/heziShopImg.png) no-repeat;
  background-size: cover;
}
.shop-top {
  /* background-color: #FF0040; */
  padding: 0.3rem 0.2rem;
}
img {
  width: 100%;
}
a {
  display: inline-block;
}
.shop-fiex-img {
  /* display: flex;
  justify-content: space-between; */
  float: left;
  margin: 5px 0 8px;
  width: 48%;
}
/* .shop-fiex-img a {
  width: 48%;
} */
.shop-footer {
  float: left;
  /* height: 130px; */
  /* background-color: #FF0040; */
  color: #ffffff;
  text-align: center;
  padding-bottom: 1.62rem;
}
.footer-top {
  font-weight: 400;
  font-size: 0.24rem;
}
.footer-btn {
  margin: 0.2rem 0 0.62rem;
}
.btnA {
  display: inline-block;
  padding: 0.16rem 0.3rem;
  color: #ffffff;
  border-radius: 99999px;
}
.btn-one {
  margin-right: 0.58rem;
  background-color: #deecff;
  color: #2376eb;
}
.btn-two {
  background-color: #ffcece;
  color: #ff0000;
}
.footer-bottom {
  letter-spacing: 0.2rem;
  font-weight: 400;
}
.end-time {
  position: absolute;
  left: 50%;
  top: 18%;
  color: #ff2210;
  font-size: 0.24rem;
}
.end-time span {
  display: inline-block;
  width: 1.4em;
  text-align: center;
  color: #fff;
  background-color: #ff2210;
  padding: 0;
}
.shop-top .shop-fiex-img:nth-last-child(2) {
  float: right;
}
.shop-top .shop-fiex-img:nth-last-child(4) {
  float: right;
}
.footer-txt {
  width: 100%;
  margin-top: 0.08rem;
}
.footer-txt img {
  width: 84%;
}

@media screen and (min-width: 960px) {
  .shop-hezi {
    font-size: 0.14rem;
    width: 3.75rem;
    margin: 0 auto !important;
  }

  .end-time {
    font-size: 0.14rem;
  }

  .footer-top {
    font-size: 0.12rem;
  }

  .footer-bottom {
    letter-spacing: 0.1rem;
  }

  .shop-footer {
    padding-bottom: .75rem;
  }

  .footer-btn {
    margin: 0.1rem 0 0.21rem;
  }

  .btn-one {
    margin-right: .2rem;
  }

  .btnA {
    padding: 0.1rem 0.15rem;
  }

  .shop-top {
    padding: 0.3rem 0.2rem .16rem;
  }

  .shop-topOne {
    padding: 1rem 0.2rem;
  }
}
</style>